import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const InducedLactationIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M17,7.62l-.84-1.25-.83,1.25c-.75,1.12-4.48,6.87-4.48,9.41A5.32,5.32,0,1,0,21.5,17C21.5,14.49,17.77,8.74,17,7.62Zm-.84,12.73A3.32,3.32,0,0,1,12.87,17c0-1.26,1.79-4.55,3.31-7,1.53,2.46,3.32,5.75,3.32,7A3.32,3.32,0,0,1,16.18,20.35Z" />
      <path d="M5.42,13.69l-.84,1.25c-.62,1-2.08,3.27-2.08,4.49a2.92,2.92,0,1,0,5.83,0c0-1.22-1.45-3.54-2.08-4.49Zm0,6.66a.93.93,0,0,1-.92-.92,7.51,7.51,0,0,1,.92-2,7.57,7.57,0,0,1,.91,2A.93.93,0,0,1,5.42,20.35Z" />
      <path d="M8.72,3,7.89,1.75,7.05,3c-.62.93-2.63,4.09-2.63,5.63a3.47,3.47,0,1,0,6.94,0C11.36,7.09,9.34,3.93,8.72,3Zm-.83,7.1A1.47,1.47,0,0,1,6.42,8.63,10.61,10.61,0,0,1,7.89,5.44,10.88,10.88,0,0,1,9.36,8.63,1.47,1.47,0,0,1,7.89,10.1Z" />
    </SvgIcon>
  )
}
export default InducedLactationIcon
